<template>
    <div class="end-screen"> 
        <transition name="fade1"  >
            <div class="absolute-container">
                <div class="section-content d-flex justify-content-center align-items-center">
                    <div class="container d-flex justify-content-center">
                        <div class="card card-demo" > 
                            <div class="card-body" v-if="lessonController.options.mode=='review' && lessonController.loadErrorType =='no-content'">
                                <h1>Review Queue Empty</h1>

                                <p>Good job! You've cleared your review queue!</p>
                                <a class="btn btn-secondary mr-2" href="/dashboard"  >Back to Dashboard</a>  
                                <a class="btn btn-secondary mr-2" v-if="courseUid"  :href="courseHref" >Continue to Course</a>
                            </div>
                            <div class="card-body" v-else-if="lessonController.loadErrorType =='completed'">
                                <h1>Completed!</h1>

                                <p>Good job! You've completed this lesson!</p>

                                <button :disabled="!lessonController.restarted && !restarted" class="btn btn-primary mr-2" @click="restart">Restart Lesson</button>  
                                <a class="btn btn-secondary mr-2" href="/dashboard"  >Back to Dashboard</a>  
                                <a class="btn btn-secondary mr-2" v-if="courseUid"  :href="courseHref" >Continue to Course</a>
                            </div>
                            <div class="card-body" v-else-if="lessonController.loadErrorType =='no-content'">
                                <h1>No Content</h1>

                                <p>Ooops, we tried to open this lesson but it contains no content.</p>

                                <a class="btn btn-secondary mr-2" href="/dashboard"  >Back to Dashboard</a>  
                                <a class="btn btn-secondary mr-2" v-if="courseUid"  :href="courseHref" >Continue to Course</a>
                            </div>
                            <div class="card-body" v-else>
                                <h1>Ooops</h1>

                                <p>Uh-oh.  We've encountered an error.</p>

                                <a class="btn btn-secondary mr-2" href="/dashboard"  >Back to Dashboard</a>  
                                <a class="btn btn-secondary mr-2" v-if="courseUid"  :href="courseHref" >Continue to Course</a>
                            </div>
                        </div> 
                    </div>

                </div>
            </div>
        </transition>
  
    </div>
</template>

<script lang="ts"> 
import {Options, Prop,Watch,Inject, Vue } from 'vue-property-decorator';
import { LessonController } from '@/controllers/LessonController'; 
import LessonItem from '@/components/course/LessonItem.vue';
import Icon from '@/components/core/Icon.vue';
import { Guid } from '@/EmurseCore';
import {getCourseUidFromController, getCourseHrefFromController} from './CardViewer';

@Options({components:{ LessonItem, Icon}})
export default class LessonErrorScreen extends Vue
{   
    @Prop() public lessonController!: LessonController
    public restarted = false;
 
    public restart()
    {
        location.reload();
    }

    public get course()
    {
        return {uid: this.courseUid};
    }

    public get courseHref()
    {
        return getCourseHrefFromController(this.lessonController);
    }

    public get courseUid()
    {
        return getCourseUidFromController(this.lessonController);
    }

    public mounted()
    {
        this.lessonController.events.once("restarted", ()=>{
            this.restarted = true;
        })
    }

}
</script>

<style lang="scss" scoped>
@import '@/theme/_helpers.scss';
 
    .end-screen {
        width:100vw;
        height:100vh;
        position: relative; 
       
        >.absolute-container {
            position:absolute;
            top:0px;
            right:0px;
            bottom:0px;
            left:0px;
            display: flex;
            align-content: center;
            align-items: center;
            justify-content: center;
            justify-items: center;
            z-index:1
        }
    }

</style> 
 